/**
 * Client-side gate for org-logo uploads. Stricter than the server's
 * upload/presign limits (which allow 20 MB and more MIME types) because a
 * logo only ever needs to be a small square image. Codes map to i18n
 * messages in LogoCropDialog.
 */
export const LOGO_MAX_BYTES = 2 * 1024 * 1024;

export const LOGO_MIME_TYPES = ['image/png', 'image/jpeg', 'image/webp'] as const;

export type LogoFileError = 'TYPE' | 'SIZE' | null;

export function validateLogoFile(file: { type: string; size: number }): LogoFileError {
  if (!LOGO_MIME_TYPES.includes(file.type as (typeof LOGO_MIME_TYPES)[number])) return 'TYPE';
  if (file.size > LOGO_MAX_BYTES) return 'SIZE';
  return null;
}
